__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "ue-wof";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.11.8", () => (__webpack_require__.e(5335).then(() => (() => (__webpack_require__(65335))))));
			register("@bolt/components", "2.5.6", () => (__webpack_require__.e(855).then(() => (() => (__webpack_require__(70855))))));
			register("@bolt/foundations", "1.15.2", () => (__webpack_require__.e(1148).then(() => (() => (__webpack_require__(51148))))));
			register("@ue/commons", "1.100.2", () => (__webpack_require__.e(4576).then(() => (() => (__webpack_require__(64576))))));
			register("@ue/experience-context", "1.4.1", () => (__webpack_require__.e(804).then(() => (() => (__webpack_require__(38423))))));
			register("@ue/i18n", "0.6.2", () => (__webpack_require__.e(8905).then(() => (() => (__webpack_require__(98905))))));
			register("@ue/navigation", "1.2.7", () => (__webpack_require__.e(3687).then(() => (() => (__webpack_require__(26068))))));
			register("@ue/product-pod", "4.19.6", () => (__webpack_require__.e(3363).then(() => (() => (__webpack_require__(53363))))));
			register("graphql", "16.9.0", () => (__webpack_require__.e(3942).then(() => (() => (__webpack_require__(23942))))));
			register("react-dom", "18.3.1", () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))));
			register("react-router-dom", "6.30.4", () => (__webpack_require__.e(2648).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};